import { isProduction } from './environment';

// allow for product developers to connect to staging instance
// testing tenant pattern: atl-vertigo--jira-jira-branch-foo--bar
// short tenant pattern: atl-vertigo--jira-(jes/jed)-foo--bar
export const isTestTenantByName = (siteName: string) => {
	if (isProduction()) return false;
	const TEST_TENANT_PATTERN =
		/^atl-vertigo--(((?:jira|j|rolex|stg)+-jira-branch-[^-]+--)|(conf-(conf|stg)-proxy-\w+--[\w-]+)).*$/;
	const SHORT_TEST_TENANT_PATTERN = /^atl-vertigo--jira-(jes|jed)-[^-]+--.*$/;
	return (
		TEST_TENANT_PATTERN.test(siteName) ||
		SHORT_TEST_TENANT_PATTERN.test(siteName) ||
		siteName.includes('polli.signup')
	);
};
